(function() {
  'use strict';

  angular.module('sempraWebapp').filter('removews', removews);

  /** @ngInject */
  function removews() {
    return function(text) {
      if (!text) return;

      var decoded = text;
      var decodedAgain = decodeURIComponent(decoded);
      while (decoded !== decodedAgain) {
        decoded = decodedAgain;
        decodedAgain = decodeURIComponent(decoded);
      }
      return decoded;
    };
  }
})();
